var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9921 13.8741C15.6945 13.8741 17.0204 10.2889 17.3707 7.34741C17.7959 3.72963 16.0281 1 11.9921 1C7.9561 1 6.18826 3.72963 6.61354 7.35556C6.96377 10.297 8.28965 13.8741 11.9921 13.8741Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9983 20.2296C21.9566 19.0889 21.8232 18.9096 21.6147 17.7852C21.3645 16.4244 21.0477 15.6341 19.8219 14.7459C19.1131 14.2326 18.1874 14.0615 17.3786 13.7518C16.9866 13.6052 16.6281 13.4503 16.2945 13.2792C15.1688 14.4689 13.7011 15.0963 12 15.0963C10.2906 15.0963 8.83125 14.4689 7.70551 13.2792C7.37195 13.4503 7.02172 13.597 6.62146 13.7518C5.80425 14.0615 4.88697 14.2326 4.17817 14.7459C2.95236 15.6341 2.63548 16.4244 2.38532 17.7852C2.17685 18.9096 2.04343 19.0889 2.00173 20.2296C1.96838 21.1178 2.41867 21.24 3.18585 21.5089C4.14482 21.8429 5.1288 22.0874 6.12946 22.2911C8.03906 22.6822 10.0154 22.9837 11.9917 23C13.968 22.9837 15.9443 22.6822 17.8706 22.2911C18.8629 22.0874 19.8552 21.8429 20.8142 21.5089C21.573 21.24 22.0317 21.1178 21.9983 20.2296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.ea10062aded6d753b7de5bf04c16a131.svg";
export { ForwardRef as ReactComponent };